import { globalKeys } from 'assets/data/global-keys';
import type { IInfoResponse } from '~/interfaces/dto/marketing/response';

export const getUserDeviceInfo = () => {
  const { $storageService } = useServices();
  return $storageService.getSessionStorage<IInfoResponse>({
    key: globalKeys.siteConfigKeys.deviceInfo,
  });
};
